module.exports = __webpack_public_path__ + "static/media/loyalty_selectOffer.43ff17cd.png";